"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
const contexts_1 = require("@App/contexts");
const publisher_side_bar_state_1 = require("@App/enum/publisher-side-bar-state");
const removers_1 = require("@App/helpers/work-entities/removers");
require("./index.scss");
const publishers_table_schema_1 = require("@Entities/schemas/wizardFlow/publishers-table-schema");
const TablesForm_1 = __importDefault(require("@Components/ViewWork/Table/TablesForm"));
const AddPublishersTableInfo_1 = __importDefault(require("@Scenes/WorkScenes/Steps/PublishersSteps/PublishersStep/AddPublishersArea/AddPublishersTableInfo/AddPublishersTableInfo"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const tooltip_text_1 = require("@Const/tooltip-text");
const SharesInfo_1 = __importDefault(require("@Components/ViewWork/SharesInfo"));
const calculate_total_known_shares_1 = __importDefault(require("@App/helpers/work-entities/utils/calculate-total-known-shares"));
const AddPublishersTable = () => {
    const { workStore, popupStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const workDraftFromLocal = workStore.workDraftLocal;
    if (!workDraftFromLocal) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const [tableIsValid, setTableIsValid] = (0, react_1.useState)(false);
    const originPublishers = workDraftFromLocal.originalPublishers;
    const stepValidator = () => {
        workStore.setWizardStepValidation(workDraftFromLocal.originalPublishers.length > 0 && tableIsValid);
    };
    (0, react_1.useEffect)(() => {
        stepValidator();
    }, [workStore.workDraftLocal, tableIsValid]);
    const removeOriginalPublisher = (removingOP) => {
        if (!workStore.workDraftLocal) {
            return;
        }
        const updatedWorkDraft = (0, removers_1.originalPublisherRemover)(removingOP, workDraftFromLocal);
        workStore.setWorkDraftToLocal(updatedWorkDraft);
    };
    const getOnRemoveCellClicked = (index, removeCellIdentifier, reset, values) => {
        if (values && reset) {
            const [originalPublisherIndex, administratorIndex] = removeCellIdentifier
                .split('-')
                .map((val) => Number.parseInt(val, 10));
            if (administratorIndex !== undefined) {
                const currentPublisher = originPublishers[originalPublisherIndex];
                const administratorToRemove = currentPublisher.administratorPublishers[administratorIndex];
                const updatedWorkDraft = (0, removers_1.adminPublisherRemover)(administratorToRemove, currentPublisher, workDraftFromLocal);
                workStore.setWorkDraftToLocal(updatedWorkDraft);
            }
            else {
                const publisherToRemove = originPublishers[originalPublisherIndex];
                removeOriginalPublisher(publisherToRemove);
            }
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TablesForm_1.default, { className: 'add-publishers-table', headingDecoration: {
                icon: 'publishers',
                title: 'Publishers',
                required: true,
                toolTip: react_1.default.createElement(CustomToolTip_1.default, { inverse: true, type: '?', info: tooltip_text_1.TOOLTIP_TEXT.createWork.publisher }),
                rightData: react_1.default.createElement(SharesInfo_1.default, { totalShares: (0, calculate_total_known_shares_1.default)(workDraftFromLocal) }),
            }, tableInfos: (0, AddPublishersTableInfo_1.default)(), addButtonTitle: 'Add Publisher', onAddButtonClicked: () => {
                popupStore.setPublisherSidebarState(publisher_side_bar_state_1.PublisherSideBarState.addOP);
            }, onRemoveCellClicked: getOnRemoveCellClicked, validationSchema: (0, publishers_table_schema_1.generatePublishersTableSchema)(workDraftFromLocal), rowsAreValid: (value) => {
                setTableIsValid(value);
            }, onFormSubmitted: (data) => { }, shouldFocusError: false })));
};
exports.default = (0, mobx_react_1.observer)(AddPublishersTable);
